import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";
import { ArrowLeft, Calendar, User } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/blogs/${slug}`)
      .then(({ data }) => {
        setPost(data);
        document.title = (data.meta_title || data.title) + " | Eventom Blog";
        // Add meta description
        let meta = document.querySelector('meta[name="description"]');
        if (data.meta_description && meta) meta.setAttribute("content", data.meta_description);
      })
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <Layout>
        <section className="max-w-3xl mx-auto px-4 sm:px-6 py-16 text-center" data-testid="blog-not-found">
          <div className="font-display text-4xl">Story not found.</div>
          <Link to="/blog" className="btn-ghost mt-6 inline-flex"><ArrowLeft className="w-4 h-4" /> Back to journal</Link>
        </section>
      </Layout>
    );
  }
  if (!post) {
    return <Layout><div className="max-w-3xl mx-auto px-4 py-16 font-mono text-sm text-muted">Loading…</div></Layout>;
  }

  return (
    <Layout>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="blog-post-page">
        <Link to="/blog" data-testid="blog-back" className="inline-flex items-center gap-1 text-[11px] font-mono uppercase tracking-widest text-muted hover:text-lime"><ArrowLeft className="w-3 h-3" /> All stories</Link>
        <h1 className="font-display uppercase text-4xl md:text-6xl leading-[0.95] mt-4" data-testid="blog-post-title">{post.title}</h1>
        <div className="mt-3 flex flex-wrap items-center gap-4 text-[11px] font-mono uppercase tracking-widest text-muted">
          {post.author && <span className="inline-flex items-center gap-1"><User className="w-3 h-3" /> {post.author}</span>}
          {post.created_at && <span className="inline-flex items-center gap-1"><Calendar className="w-3 h-3" /> {new Date(post.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}</span>}
        </div>
        {post.cover_url && (
          <div className="mt-6 rounded-3xl overflow-hidden">
            <img src={post.cover_url} alt={post.title} className="w-full max-h-[520px] object-cover" />
          </div>
        )}
        {post.excerpt && <p className="mt-6 text-lg text-white/85 leading-relaxed" data-testid="blog-excerpt">{post.excerpt}</p>}
        <div className="mt-6 prose-eventom text-white/90 leading-relaxed whitespace-pre-wrap" data-testid="blog-body"
          dangerouslySetInnerHTML={{ __html: post.body }} />
        {post.tags?.length ? (
          <div className="mt-8 pt-6 border-t border-white/10 flex flex-wrap gap-2">
            {post.tags.map((t) => <span key={t} className="chip !text-[10px]">#{t}</span>)}
          </div>
        ) : null}
      </article>
    </Layout>
  );
}
